import { METHOD } from "./method";

export const API_NON_EMPLOYEE = {
    DELETE_EMPLOYEE: {
        api: '/v1/hr-adm/non-employee/delete',
        method: METHOD.DELETE
    },
    CREATE_EMPLOYEE: {
        api: '/v1/hr-adm/non-employee',
        method: METHOD.POST
    },
    CREATE_DRAFT_EMPLOYEE: {
        api: '/v1/hr-adm/non-employee/draft',
        method: METHOD.POST
    },
    LIST_EMPLOYEE: {
        api: '/v1/hr-adm/non-employee/list',
        method: METHOD.POST
    },
    EXPORT_EMPLOYEE: {
        api: '/v1/hr-adm/non-employee/export',
        method: METHOD.POST
    },
    LIST_CONSTANTS_EMPLOYEE: {
        api: '/v1/hr-adm/non-employee/constants',
        method: METHOD.GET
    },
    LIST_BANK: {
        api: '/v1/hr-adm/non-employee/banks',
        method: METHOD.GET
    },
    VALIDATE_BANK_ACCOUNT: {
        api: '/v1/hr-adm/non-employee/bank/validate',
        method: METHOD.POST
    },
    LIST_COMPANY: {
        api: '/v1/hr-adm/non-employee/companies',
        method: METHOD.GET
    },
    LIST_JOB_TITLE: {
        api: '/v1/hr-adm/non-employee/job-titles',
        method: METHOD.GET
    },
    DETAIL: {
        api: '/v1/hr-adm/non-employee',
        method: METHOD.GET
    },
    UPDATE_PERSONAL_DETAIL: {
        api: '/v1/hr-adm/non-employee/personal-detail',
        method: METHOD.PUT
    },
    UPDATE_ADDITIONAL_INFORMATION: {
        api: '/v1/hr-adm/non-employee/additional-info',
        method: METHOD.PUT
    },
    JOB_TITLE: {
        api: '/v1/hr-adm/non-employee/job-title',
        method: METHOD.POST
    },
    URL_PROFILE_PICTURE: {
        api: '/v1/hr-adm/non-employee/storage-url/profile-picture',
        method: METHOD.POST
    },
    UPDATE_BANK: {
        api: '/v1/hr-adm/non-employee/bank',
        method: METHOD.PUT
    },
    LIST_JOB_UNIT: {
        api: '/v1/hr-adm/non-employee/job-unit',
        method: METHOD.POST
    },
    CHANGE_PASSWORD: {
        api: '/v1/hr-adm/non-employee/change-password',
        method: METHOD.POST
    }
}
